import script from "./ViewNotFound.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewNotFound.vue?vue&type=script&setup=true&lang=ts"

import "./ViewNotFound.vue?vue&type=style&index=0&id=0611b0a2&scoped=true&lang=scss"

import exportComponent from "/Users/thibertletullier/Workspace/Declic/comex/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0611b0a2"]])

export default __exports__